"use client";

// Back-compat re-export. The implementation moved to
// @/ui/components/locale-channel/locale-channel-trigger.
// Delete this file after all consumers update their imports.
export { LocaleChannelTrigger as LocaleChannelDropdown } from "@/ui/components/locale-channel/locale-channel-trigger";
